import debounce from "lodash.debounce";
import { useEffect, useMemo, useState } from "react";

export const useDebouncedSearch = (inputValue: string, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(inputValue);
  const debouncedSet = useMemo(
    () => debounce(setDebouncedValue, delay),
    [delay]
  );

  useEffect(() => {
    if (!inputValue) {
      debouncedSet.cancel();
      setDebouncedValue(inputValue);
    } else {
      debouncedSet(inputValue);
    }
    return () => debouncedSet.cancel();
  }, [inputValue, debouncedSet]);

  return debouncedValue || undefined;
};
